(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["galleria-con-overlay"] && !Shopify.designMode) return;
  try {
    
const modal = document.getElementById("imageModal");
const modalImg = document.getElementById("fullImage");
const captionText = document.getElementById("caption");
const galleryImages = [...document.querySelectorAll('.image-item img')];
const closeBtn = document.querySelector(".close");
const prevBtn = document.querySelector(".arrow.left");
const nextBtn = document.querySelector(".arrow.right");

let currentIndex = 0;

function showModal(index) {
  const img = galleryImages[index];
  currentIndex = index;
  modalImg.src = img.dataset.full;
  modalImg.setAttribute("width", img.naturalWidth);
  modalImg.setAttribute("height", img.naturalHeight);
  captionText.textContent = img.alt;

  modal.style.visibility = "visible";
  requestAnimationFrame(() => {
    modal.style.opacity = "1";
  });
}

galleryImages.forEach((img, index) => {
  img.addEventListener("click", () => showModal(index));
});

function closeModal() {
  modal.style.opacity = "0";
  modal.addEventListener("transitionend", () => {
    modal.style.visibility = "hidden";
  }, { once: true });
}

function showNext() {
  currentIndex = (currentIndex + 1) % galleryImages.length;
  showModal(currentIndex);
}

function showPrev() {
  currentIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
  showModal(currentIndex);
}

closeBtn.addEventListener("click", closeModal);
modal.addEventListener("click", (e) => {
  if (e.target === modal) closeModal();
});
nextBtn.addEventListener("click", showNext);
prevBtn.addEventListener("click", showPrev);
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") closeModal();
  if (e.key === "ArrowRight") showNext();
  if (e.key === "ArrowLeft") showPrev();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-overlay"] && !Shopify.designMode) return;
  try {
    
  class VideoOverlayModal {
    constructor() {
      this.triggers = document.querySelectorAll('[data-video-overlay-trigger]');
      this.bindEvents();
    }

    bindEvents() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const sectionId = trigger.dataset.videoOverlayTrigger;
          this.openModal(sectionId);
        });
      });

      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-video-overlay-close]')) {
          const modal = e.target.closest('[data-video-overlay-modal]');
          if (modal) {
            this.closeModal(modal);
          }
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const openModal = document.querySelector('[data-video-overlay-modal][aria-hidden="false"]');
          if (openModal) {
            this.closeModal(openModal);
          }
        }
      });
    }

    openModal(sectionId) {
      const modal = document.getElementById(`video-overlay-modal-${sectionId}`);
      if (!modal) return;

      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      const video = modal.querySelector('[data-video-overlay-player]');
      if (video) {
        video.play().catch(() => {});
      }

      const closeButton = modal.querySelector('[data-video-overlay-close]');
      if (closeButton) {
        closeButton.focus();
      }
    }

    closeModal(modal) {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';

      const video = modal.querySelector('[data-video-overlay-player]');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      const iframe = modal.querySelector('[data-video-overlay-iframe]');
      if (iframe) {
        const src = iframe.src;
        iframe.src = '';
        iframe.src = src;
      }

      const sectionId = modal.id.replace('video-overlay-modal-', '');
      const trigger = document.querySelector(`[data-video-overlay-trigger="${sectionId}"]`);
      if (trigger) {
        trigger.focus();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new VideoOverlayModal());
  } else {
    new VideoOverlayModal();
  }

  } catch(e) { console.error(e); }
})();
})();
